export default __webpack_public_path__ + "static/media/Circle_of_Influence_Concern.c184a119.png";